let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("e1zG7")).then(() => parcelRequire('bbMoQ'));